<template>
	<AppLayout />
</template>
<style lang="scss">
@use '@/assets/scss/style.scss';
</style>
